import i18n from "../../../i18n.config";

/** Google Speech-to-Text language code from active UI locale. */
export function resolveIntakeSpeechLanguageCode(): string {
  const lang = i18n.language ?? i18n.resolvedLanguage ?? "en";
  return lang.startsWith("es") ? "es-US" : "en-US";
}
